// TicketChat.jsx
import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

const socket = io('https://8kl4c01f-9888.inc1.devtunnels.ms/');

const TicketChat = ({ ticketId, sender }) => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // Join ticket room
    socket.emit('join_ticket', ticketId);

    // Receive all previous messages
    socket.on('load_messages', (data) => {
      setMessages(data);
    });

    // Listen for new messages
    socket.on('receive_message', (msg) => {
      setMessages(prev => [...prev, msg]);
    });

    return () => {
      socket.off('receive_message');
      socket.off('load_messages');
    };
  }, [ticketId]);

  const sendMessage = () => {
    if (message.trim()) {
      socket.emit('send_message', {
        ticketId,
        sender:"Admin",
        message
      });
      setMessage('');
    }
  };

  return (
    <div>
      <h3>Ticket Chat</h3>
      <div style={{ height: 300, overflowY: 'auto', border: '1px solid #ccc', padding: 10 }}>
        {messages.map((msg, idx) => (
          <div key={idx}>
            <strong>{msg.sender}</strong>: {msg.message}
          </div>
        ))}
      </div>
      <input
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type your message"
      />
      <button onClick={sendMessage}>Send</button>
    </div>
  );
};

export default TicketChat;